var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AutobuyerToggleLabel',{attrs:{"is-active":_vm.isActive,"is-disabled":_vm.isDisabled,"name":_vm.name},on:{"click":_vm.emitClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }